import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectPage = () => {
  const { navigation } = useNavigation()

  return <Navigate replace to={navigation.inbox.todo.fullPath()} />
}

export default RedirectPage
